import { render, staticRenderFns } from "./CalvingTab.vue?vue&type=template&id=472ae836&"
import script from "./CalvingTab.vue?vue&type=script&lang=js&"
export * from "./CalvingTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports